<div class="dialog-wrapper">
  <button class="close-button" (click)="dialogRef.close()" aria-label="Cerrar">✖</button>
  <iframe [src]="htmlSanitized" title="Analisis de Prescripcion"></iframe>
</div>
